@if (dashboard && dashboard.logo) {
  <img
    class="logo"
    [ngClass]="{ 'mobile-logo': (isMobile$ | async).isMobile }"
    [src]="dashboard.logo | base64ToImageUrl"
    [alt]="'Logo of dashboard: ' + dashboard.customer"
    />
}
